// extracted by mini-css-extract-plugin
module.exports =  {"tf-array-text-mode":"TextModeArrayTemplate-module__tf-array-text-mode___NSHnU"};